import React from 'react';
import {Copyright} from '.';

export const Footer = (props: any) => {
	return (<>
		<footer className='container-fluid text-light text-center g-0 m-0 p-5   bg-secondary'>
			<Copyright/>
		</footer>
	</>);
};

